import * as React from "react";

export const SvgIconOneWay = ({ "data-testid": dataTestId = null, ...props }) => (
	<svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" data-testid={dataTestId} {...props}>
		<path
			d="m19.773 12.634.027-.036c.01-.014.022-.028.031-.043.01-.014.018-.029.027-.044l.024-.04.022-.045.02-.043.016-.045.017-.048.011-.045c.005-.017.01-.033.012-.05.004-.017.006-.035.009-.053l.006-.043a1.017 1.017 0 0 0 0-.198l-.006-.043c-.003-.018-.005-.036-.009-.053-.003-.017-.007-.034-.012-.05l-.011-.045-.017-.048-.016-.045-.02-.043-.022-.045-.024-.04c-.009-.015-.017-.03-.027-.044l-.03-.043-.028-.036a1.013 1.013 0 0 0-.065-.072v-.001l-4-4a1 1 0 1 0-1.415 1.414L16.586 11H5a1 1 0 1 0 0 2h11.586l-2.293 2.293a1 1 0 1 0 1.414 1.414l4-4 .001-.001c.023-.023.045-.047.065-.072Z"
			fill={props.color ?? "#222"}
		/>
	</svg>
);
